export default __webpack_public_path__ + "static/media/community2.4be35e04.jpg";